import { gql, useQuery } from '@apollo/client';
import { Modal } from 'antd';
import { get, map } from 'lodash';
import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { USE_CART } from '../../config';

const formatPrice = (price) => {
  if (!price) {
    return null;
  }
  return `${(price / 100).toFixed(2)} €`;
};

export const AddProduct = ({ productId, size = 'normal' }) => {
  const dispatch = useDispatch();
  const selectProductQty = useCallback(
    (state) => {
      return state.cart.qty[productId] || 0;
    },
    [productId]
  );

  const qty = useSelector(selectProductQty);
  if (!USE_CART) {
    return null;
  }

  return (
    <div className={classnames('add-product-container', `add-product-${size}`)}>
      <button
        className="app-button"
        style={{ visibility: qty > 0 ? 'inherit' : 'hidden' }}
        onClick={(e) => {
          if (qty) {
            dispatch({ type: 'REMOVE_PRODUCT', productId });
          }
          e.stopPropagation();
        }}
      >
        <FontAwesomeIcon icon={faMinusCircle} />
      </button>
      <span
        style={{ visibility: qty > 0 ? 'inherit' : 'hidden' }}
        className="add-product-qty"
      >
        {qty}
      </span>
      <button
        className="app-button"
        onClick={(e) => {
          dispatch({ type: 'ADD_PRODUCT', productId });
          e.stopPropagation();
        }}
      >
        <FontAwesomeIcon icon={faPlusCircle} />
      </button>
    </div>
  );
};

export const ProductCard = ({
  productId,
  coverUrl,
  name,
  price,
  onImageLoad,
  promotion,
  inStock,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="product-item">
      <div
        className={classnames('product-item-content', {
          'product-item-no-stock': !inStock,
        })}
        onClick={() => setOpen(true)}
      >
        {coverUrl && (
          <img
            className="product-item-cover"
            src={coverUrl}
            alt="name"
            onLoad={onImageLoad}
          />
        )}
        {!coverUrl && <div className="product-item-cover-placeholder" />}
        <div
          className="product-item-text"
          style={{ flexGrow: coverUrl ? 1 : 0 }}
        >
          <div className="product-item-name">{name}</div>
          {Boolean(price || promotion) && (
            <div className="product-item-price">
              <span
                style={{
                  textDecoration: promotion ? 'line-through' : 'none',
                  marginRight: 5,
                }}
              >
                {formatPrice(price)}
              </span>
              {Boolean(promotion) && formatPrice(promotion)}
            </div>
          )}
        </div>
        {!inStock && (
          <div className="product-item-out-of-stock">Rupture de stock</div>
        )}
        {inStock && <AddProduct productId={productId} />}
      </div>
      <Modal
        width="80%"
        visible={open}
        onCancel={() => setOpen(false)}
        maskClosable
        footer={null}
      >
        <ProductDetail productId={productId} />
      </Modal>
    </div>
  );
};

const GET_PRODUCT = gql`
  query product($id: ID!) {
    product(id: $id) {
      id
      name
      price
      covers {
        id
        url
      }
      inStock
    }
  }
`;

const ProductDetail = ({ productId }) => {
  const { data } = useQuery(GET_PRODUCT, {
    variables: {
      id: productId,
    },
  });
  const product = get(data, 'product');

  return (
    <div className="product-detail">
      <div className="product-detail-images">
        {map(get(product, 'covers'), (c) => (
          <div key={c.id} className="">
            <img src={c.url} alt="" />
          </div>
        ))}
      </div>
      <div className="product-detail-name">{get(product, 'name')}</div>
      <div className="product-detail-price">
        {formatPrice(get(product, 'price'))}
      </div>
      <AddProduct productId={productId} size="large" />
    </div>
  );
};
